<template>
  <div :class="classNames">
    <div class="content">
      <p v-if="label && !hideLabel" class="label subtitle-2">
        {{ label }}
      </p>
      <helpIcon v-if="helpContent" :content="helpContent"/>
    </div>
    <fields
      :rows="layout"
      :category="category"
      :parentField="id"
      :id="ruleId"
      :hideLabel="hideLabel"
    />
  </div>
</template>
    
<script>
import fieldMap from "./field-map.json";
import helpIcon from "@/components/help-icon";

export default {
  components: { fields: () => import("../config-tab/fields"), helpIcon },
  props: {
    helpContent: {
      type: String
    },
    category: {
      type: String,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    layout: {
      type: Array,
    },
    ruleId: {
      type: String,
    },
    parentField: {
      type: String,
    },
  },
  computed: {
    classNames() {
      let classNames = ["objectElement"];
      if (this.getFieldValue('showHighlight')) {
        classNames.push('show-highlight');
      } 
      if (this.getFieldValue('showBorder')) {
        classNames.push('show-border')
      } 
      if (this.getFieldValue('groupPosition')) {
        classNames.push('groupPosition-' + this.getFieldValue('groupPosition'));
      }
      return classNames;
    },
  },
  methods: {
    getFieldValue(value) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][this.id] &&
        fieldMap[this.category][this.id][value]
      );
    },
  },
};
</script>

<style lang="scss" scoped>

.content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $qvo-spacing-8;
  margin-bottom: $input-label-spacing;
}

.show-highlight {
  background: $qvo-color-blue-100;
  padding: $qvo-spacing-16;
  border-radius: 8px;
  margin-bottom: $qvo-spacing-24;
}
.show-border {
  padding: $qvo-spacing-16;
  border: 1px solid $qvo-color-grey-200;
  border-radius: 9px;
  margin-bottom: $qvo-spacing-24;
}
.groupPosition-first {
  border-radius: 9px 9px 0 0;
  border-bottom: none;
  margin-bottom: 0;
}

.groupPosition-middle {
  border-radius: 0;
  margin-bottom: 0;
  border-bottom: none;
}

.groupPosition-last  {
  border-radius: 0 0 9px 9px;
  margin-bottom: $qvo-spacing-24;
}
</style>